import { useState } from 'react'
import { Modal } from 'components'
import axios from 'axios'
import { useAuth } from 'contexts/auth-context'
import nProgress from 'nprogress'
import toast from 'react-hot-toast'
import Form from './form'
import { lang } from 'config'

const Content = ({ data, success }) => {
    const { user } = useAuth()

    const [errors, setErrors] = useState({})

    const handleSubmit = (payload) => {
        nProgress.start()

        const fd = new FormData()
        fd.append("name", payload.name ?? "")
        fd.append("code", payload.code ?? "")
        fd.append("is_ho", payload.is_ho ? "1" : "0")
        fd.append("contact", payload.contact ?? "")
        fd.append("address", payload.address ?? "")
        if (payload.latitude !== null && payload.latitude !== undefined) fd.append("latitude", String(payload.latitude))
        if (payload.longitude !== null && payload.longitude !== undefined) fd.append("longitude", String(payload.longitude))
        if (payload.image) fd.append("image", payload.image)
        fd.append("updated_by", user?.name ?? "")

        // NEW: open_hours + display_note
        fd.append("display_note", payload.display_note ?? "")
        if (payload.open_hours !== undefined && payload.open_hours !== null) {
            fd.append(
            "open_hours",
            typeof payload.open_hours === "string" ? payload.open_hours : JSON.stringify(payload.open_hours)
            )
        }

        // Method spoofing for Laravel compatibility
        fd.append("_method", "PATCH")

        axios
            .post(`${process.env.REACT_APP_GENERIC_API_URL}/branch/${payload.id}`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
            success()
            toast.success(response.data.message)
            })
            .catch((error) => {
            if (error?.response?.status === 422) setErrors(error.response.data.errors)
            toast.error(error?.response?.data?.message || "Request failed")
            console.log(error)
            })
            .finally(() => {
            nProgress.done()
            })
        }


    return (
        <Form errors={errors} data={data} onSubmit={handleSubmit} />
    )
}

const Edit = ({ data, onSuccess }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSuccess = () => {
        closeModal()
        onSuccess()
    }

    return (
        <>
            <button onClick={openModal} class="inline-flex items-center p-1 text-white transition bg-neutral-800 rounded-full active:hover:scale-90">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
                    <line x1="13.5" y1="6.5" x2="17.5" y2="10.5"></line>
                </svg>
            </button>
            <Modal isOpen={isOpen} onClose={closeModal} title={`${lang.edit} ${lang.branch}`} content={<Content data={data} success={handleSuccess} />} />
        </>
    )
}

export default Edit